import React, { PropTypes } from 'react';
import Item from 'common/components/entry_gallery/item';

const ImageNameList = ({ items, itemVariation, ...otherProps }) => {
  return (
    <div className="row small-up-1 project-entries-gallery list">
      { items.map((item, i) => (
      <Item key={i} item={item} variation={itemVariation} {...otherProps} />
      )) }
    </div>
  );
}

ImageNameList.propTypes = {
  items: PropTypes.array.isRequired,
  itemVariation: PropTypes.string.isRequired,
};

export default ImageNameList;



// WEBPACK FOOTER //
// ./common/components/entry_gallery/image_name_list.jsx